module.exports = __webpack_public_path__ + "static/media/search.1e93ee13.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/search.svg
// module id = 1763
// module chunks = 0